export default {
  header: "Submit",
  page: "Submit",
  dogs: [],
};
